<template>
  <div>
    <game-title-layout :show-top="showTop"></game-title-layout>
    <div v-if="isMapsInDetail">
      <SlotsMapsDetailLayout
        :mapList ="mapList"
        :mapListDetail ="mapListDetail"
        :mapIndex="mapIndex"
        :lang="lang"
        :Phone = "Phone"
        :linesId="getLinesId()"
        :checkFreeColor="checkFreeColor"
        :remainFreeCount="remainFreeCount"
        :sumRows="sumRows"
        :sumColumns="sumColumns"
        :freeId = "freeId"
        :imgAreaClassId="imgAreaClassId"
        :imgImgDetailClassId="imgImgDetailClassId"
        :checkScatterWin ="checkScatterWin"
        :scatterWin ="scatterWin"
        :scatterItem ="scatterItem"
        :mapTopClass="mapTopClass"
        :mapBottomClass="mapBottomClass"
        :isCheckTable="isCheckTable"
        :checkTable="checkTable"
        :gamePath="gamePath" />
    </div>
    <div v-if="!isMapsInDetail">
      <SlotsDetailLayout
        :mapList ="mapList"
        :mapListDetail ="mapListDetail"
        :mapIndex="mapIndex"
        :lang="lang"
        :Phone = "Phone"
        :linesId="getLinesId()"
        :checkFreeColor="checkFreeColor"
        :remainFreeCount="remainFreeCount"
        :sumRows="sumRows"
        :sumColumns="sumColumns"
        :freeId = "freeId"
        :imgAreaClassId="imgAreaClassId"
        :imgImgDetailClassId="imgImgDetailClassId"
        :checkScatterWin ="checkScatterWin"
        :scatterWin ="scatterWin"
        :scatterItem ="scatterItem"
        :mapTopClass="mapTopClass"
        :mapBottomClass="mapBottomClass"
        :isCheckTable="isCheckTable"
        :checkTable="checkTable"
        :gamePath="gamePath" />
    </div>
    <SlotsWinTotalLayout :show-total="showTotal" :win-value-total="winValueTotal"></SlotsWinTotalLayout>
  </div>
</template>
<script>
  import slots_win_total_layout from "./slots_win_total_layout.vue";
  import slots_detail_layout from "./slots_detail_layout.vue";
  import SlotsMapsDetailLayout from "./slots_maps_detail_layout.vue";
  import GameTitleLayout from "../../common/game_detail_title.vue";
  export default
  {
    name: "SlotsMapLayout",
    components: {
      GameTitleLayout,
      SlotsMapsDetailLayout,
      'SlotsDetailLayout': slots_detail_layout,
      'SlotsWinTotalLayout': slots_win_total_layout,
    },
    props: {
      showTop:false,
      gamePath:"",
      mapIndex: [],
      lang: '',
      linesId:0,
      mapList: [],
      mapListDetail: [],
      isFree: false,
      Phone: false,
      showTotal:false,
      winValueTotal:"",
      freeId:'S',
      checkFreeColor: false,
      remainFreeCount:3,
      sumRows:3,
      sumColumns:5,
      imgAreaClassId:"",
      imgImgDetailClassId:"",
      checkScatterWin: false,
      scatterWin: 0,
      scatterItem:'S',
      isMapsInDetail:false,
      mapTopClass:[],
      mapBottomClass:[],
      isCheckTable: false,
      checkTable:  [],
    },
    data() {
      return {

      };
    },
    created() {

    },
    methods: {
      getLinesId()
      {
         if(this.linesId === undefined){
           return 0;
         }
         return this.linesId;
      },
      getShowTotal(){
        if(this.showTotal){
          return Boolean(this.showTotal);
        }
        return false;
      },
    }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/slots/layout/slots_map_layout.vue